import Vue from "vue";

const getDefaultState = () => {
  return {
    RolesHorsGroupe: [],
    //field: "name",
    //whereField: "role",
    //whereValue: "superviseur",
    collection: "rolesHorsGroupe",
  };
};
const state = getDefaultState();

const mutations = {
  SET_LISTE(state, payload) {
    state.RolesHorsGroupe = payload;
  },
  RESET_STATE(state) {
    Object.assign(state, getDefaultState());
  },
};

const actions = {
  resetState({ commit }) {
    commit("RESET_STATE");
  },
  async GetAll({ commit, dispatch }) {
    // start requête
   
    commit("SET_LISTE", []);

    commit("Loading/START_BUSY_STATE", "RolesHorsGroupe GetAll", {
      root: true,
    });

    let elems = [];
    this._vm.$firebase
      .firestore()
      .collection("rolesHorsGroupe")
      .get()
      .then(
        (snapshot) => {
          snapshot.forEach(function (doc) {
            elems.push({
              ...doc.data(),
              id: doc.id,
            });
          });

          if (!elems) {
            console.log("No Data Available");
            return false;
          } else {
            commit("SET_LISTE", elems);
            commit("Loading/END_BUSY_STATE", "RolesHorsGroupe.store.js", {
              root: true,
            });
          }
        },
        (error) => {
          console.log(error);
          let snackbar = {};
          snackbar.showSnackbar = true;
          snackbar.snackbarContent = error.message;
          commit("Snackbar/SET_SNACKBAR", snackbar, { root: true });

          commit("Loading/END_BUSY_STATE", "RolesHorsGroupe.store.js", {
            root: true,
          });
        }
      );
  },
};

const getters = {
  RolesHorsGroupe: (state) => {
    return state.RolesHorsGroupe;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
